import { ChipMetadata, LinkButton } from '@pmi/dsm-react';
import { CheckmarkIcon } from '@pmi/dsm-react/dist/components/icons/avatar';
import { memo } from 'react';
import { ProductLink } from '../../../../models';
import ChapterSelectionBlock, { Chapter } from '../ChapterSelectionBlock';

interface ChapterSelectionSectionProps {
  chapterSelected: ProductLink | Chapter | null;
  changeChapter: boolean;
  isChapterSearch: boolean;
  chaptersInBundle: Chapter[];
  suggestedChapters: Chapter[];
  onChangeChapter: (value: boolean) => void;
  onChapterSearch: (searchMode: boolean) => void;
  onSelectChapter: (chapter: Chapter) => void;
}

function ChapterSelectionSection({
  chapterSelected,
  changeChapter,
  isChapterSearch,
  chaptersInBundle,
  suggestedChapters,
  onChangeChapter,
  onChapterSearch,
  onSelectChapter,
}: ChapterSelectionSectionProps) {
  return (
    <div>
      <div className="d-flex align-content-center align-items-center mb-3">
        {chapterSelected && (
          <span className="d-block me-3">{chapterSelected.title}</span>
        )}
        <ChipMetadata
          text="Chapter Membership Included"
          icon={<CheckmarkIcon />}
          variant="violet"
        />
      </div>
      {chapterSelected && (
        <>
          <div className="d-block mb-3">
            <p>
              Whether you&apos;re a first-time member or renewing your
              membership, your enrollment includes access to one PMI Chapter in
              your country. Experience the added value of community and
              knowledge sharing, all in one package!
            </p>
          </div>
          {!changeChapter &&
            !isChapterSearch &&
            chaptersInBundle.length > 1 && (
              <div className="d-block mb-3">
                <LinkButton
                  titleText="Change Chapter"
                  className="fw-normal text-decoration-underline"
                  onClick={() => onChangeChapter(true)}
                />
              </div>
            )}
        </>
      )}

      {!chapterSelected && (
        <p>
          As a part of your PMI Membership, you can select a chapter to be added
          to your membership at no additional cost. Please choose your preferred
          chapter below.
        </p>
      )}
      {changeChapter && (
        <LinkButton
          titleText="- Hide Chapters"
          className="fw-normal text-decoration-underline"
          onClick={() => {
            onChangeChapter(false);
            onChapterSearch(false);
          }}
        />
      )}
      {(changeChapter || !chapterSelected || isChapterSearch) && (
        <div>
          <ChapterSelectionBlock
            suggestedChapters={suggestedChapters}
            selectedChapter={chapterSelected}
            chapters={chaptersInBundle}
            className="mt-3"
            onSearchChapter={onChapterSearch}
            onSuggestedSelect={onSelectChapter}
            onSearchSelect={onSelectChapter}
          />
        </div>
      )}
    </div>
  );
}

export default memo(ChapterSelectionSection);
